import {FCWithChildren} from 'app/interface';
import {GemSettingsProvider} from 'app/utils/config/gemSettingsProvider';
import {GemInitializeComponents} from 'app/utils/initialize/components/gemInitializeComponents';
import {ComponentContextWrapperProps} from 'app/utils/initialize/interface';
import {GemInitializeComponentsProvider} from 'app/utils/initialize/useGemInitializeComponents';

export const ComponentContextWrapper: FCWithChildren<ComponentContextWrapperProps> = ({children, gemSettings}) => {
    return (
        <GemSettingsProvider value={gemSettings}>
            <GemInitializeComponentsProvider value={GemInitializeComponents}>{children}</GemInitializeComponentsProvider>
        </GemSettingsProvider>
    );
};
